import styled from "vue-styled-components";


export const StyleCarousel = styled.div`
.slide {
    display: flex;
    height: auto;
    overflow: hidden;
}

.slide_mobile {
    display: none;
}

.custom-nav {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 6px 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.custom-nav.prev {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
}

.custom-nav.next {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

#banner-carousel .owl-dots {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
}

#banner-carousel .owl-dot span {
    background-color: rgba(
        255,
        255,
        255,
        0.5
    ) !important; /* Estilização adicional */
    border-radius: 50%;
    width: 10px !important;
    height: 10px !important;
    margin: 5px;
    transition: background-color 0.3s;
}

.owl-dot.active span {
    background-color: rgba(255, 255, 255, 1) !important;
    border: 0 !important;
}

@media screen and (max-width: 700px) {
    .slide {
        display: none;
    }

    .slide_mobile {
        display: flex;
        height: auto;
        overflow: hidden;
    }
}
`;



export const StyleCarouselProducts = styled.div`
.carousel-products .custom-nav-product {
  color: ${props => props.theme?.carousel_products?.navigation_color ?? '#dfdfdf'};
  padding: 6px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid ${props => props.theme?.carousel_products?.navigation_color ?? '#dfdfdf'};
  border-radius: ${props => props.theme?.carousel_products?.border_radius ?? ''};
}

.carousel-products .custom-nav-product.prev {
  position: ${props => props.theme?.carousel_products?.navigation_local ?? 'unset'};
  top: 50%;
  transform: translateY(-50%);
  margin-left: ${props => props.theme?.carousel_products?.navigation_local == 'unset' ?  '-28px' : '-35px'};
}

.carousel-products .custom-nav-product.next {
  position: ${props => props.theme?.carousel_products?.navigation_local ?? 'unset'};
  top: 50%;
  margin-right: ${props => props.theme?.carousel_products?.navigation_local == 'unset' ?  '-28px' : '-35px'};
  transform: translateY(-50%);
}

.carousel-products {
  position: relative;
}

.carousel-products .owl-nav {
  position: ${props => props.theme?.carousel_products?.navigation_local ?? 'unset'};
  top: ${props => props.theme?.carousel_products?.top ?? '-17px'};
  right: 31px;
  display: flex;
  justify-content: flex-end;
}

.carousel-products .owl-nav .owl-prev,
.carousel-products .owl-nav .owl-next {
  background: none;
  border: none;
  padding: 5px;
}

.carousel-products .owl-nav .owl-prev {
  margin-right: 5px;
}

.carousel-products .custom-nav-product i {
  font-size: 16px;
}

@media (max-width: 400px) {
    #item {
        padding: 0 60px;
    }
}

@media (max-width: 999px) {
    .carousel-products .custom-nav-product.prev{
        margin-left: ${props => props.theme?.carousel_products?.navigation_local == 'unset' ?  '0px' : '-35px'};
    }

    .carousel-products .custom-nav-product.next {
        margin-right: ${props => props.theme?.carousel_products?.navigation_local == 'unset' ?  '0' : '-35px'};
    }
}
`;
